



 import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
 import AgroGenericCard from "@/components/agroGenericCard/AgroGenericCard.vue";
 import * as analysesApi from "@/api/analyses";
 import { AnalysesMonitoringCount } from "@/api/analyses/types";

 @Component({
   name: 'CardAnalysesMonitoringCount',
   components: {
     AgroGenericCard,
   }
 })

export default class CardAnalysesMonitoringCount extends Vue {
  private isLoading = false;
  private count: number | null = null;
  private analysisType: string | null = null;

  @Prop({ type: Boolean, default: false }) private onlyUserFarms!: boolean;

  async mounted() {
    this.analysisType = 'SENTINELA';
    await this.getAnalysesCount();
  };

  @Watch('onlyUserFarms')
  private async getAnalysesCount() {
    this.isLoading = true;
    try {
      const response = (await analysesApi.getAnalysesCount(this.analysisType!, this.onlyUserFarms)).data;
      this.count = response.value;
    } catch {
      this.count = null;
    } finally {
      this.isLoading = false;
    }
  }
  
}
